<div class="tab-pane" role="tabpanel" id="archivos">


    <fieldset id="archivos" class="archivos row">

        <div *ngIf="!yasubieron" class="row">
            <div align="center" class="col-md-12" style="font-size: 30px; padding-bottom: 30px; padding-top: 30px">
                <h4>
                    Archivos a adjuntar (MINVU)
                </h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12" align="center" style="padding-bottom: 20px">
                
                <p style="font-size: 14px">Tiene un máximo de <strong>75 MB</strong>, Al subir los archivos adjuntos,
                    favor presione el boton:</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12" align="center" style="padding-bottom: 20px">
                <button *ngIf="!yasubieron" mat-raised-button [@bounce]="{ value: animate, params: { duration: 1500 }}"
                    style="background-color: darkorange" (click)="confirmarSubida();"
                    [disabled]="!(files.length>0) || yasubieron">Subir archivos</button>
                    <h3 *ngIf="yasubieron" >Archivos ya fueron subidos</h3>
            </div>
        </div>

        <!-- <div class="step_section">
            <h2 class="form-signin-heading"><strong>Adjuntar los Documentos Obligatorios</strong></h2>
            <hr>
            <h4>A continuaci&oacute;n ver&aacute; un listado de documentos obligatorios, los cuales deber&aacute; adjuntar en formato PDF.</h4>
            <div class="col-md-1"></div>
            <div class="row" >
                    <div class="col-md-3 archivos" align="center">
                    
                    <div class="labelsFile"  id ="as" *ngFor="let input of inputList;">
                        
                        <label class="lname" >{{ input.name}}</label>
                        <div>
                        <label  style="width: 159px; height: 65px; text-align: center;" class="uploader-input-{{input.name}}" for="uploader-input-{{input.name}}" 
                            ng2FileDrop [ngClass]="{'another-file-over-class': input?.ready , 'nv-file-over': hasBaseDropZoneOver}"
                            (fileOver)="fileOverBase($event)"
                            (onFileDrop)="onFileDrop($event, input.name )"
                            [uploader]="uploader"
                            class="well my-drop-zone">
                            {{input?.ready ? 'Cargado' : 'Arrastrar archivo'}}</label>
                        <input type="file" ng2FileSelect (onFileSelected)="onFileDrop($event, input.name )" [uploader]="uploader" id="uploader-input-{{input.name}}" multiple style="display: none" accept="application/pdf" />
                        <label class="lObligatorio" *ngIf="input.obligatorio && !input?.ready"> Este archivo es obligatorio</label>
                    </div>
                    <hr>
                    </div>
                    
                </div>
                <div class="col-md-9">
                    <div align="right">
                        <label *ngIf="uploader.queue?.length"><strong>Cantidad</strong> de archivos subidos: {{uploader.queue.length}}</label>
                    </div>
                    <table class="table">
                        <thead>
                        <tr>
                            <th width="50%">Nombre</th>
                            <th>Tamaño</th>
                            <th>Progreso</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of uploader.queue">
                            <td><strong>{{ item?.file.name }}</strong></td>
                            <td  nowrap>{{ item?.file?.size/1024/1024  | number:'.2' }} MB</td>
                            <td >
                                <div class="progress" style="margin-bottom: 0;">
                                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span *ngIf="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span>
                                <span *ngIf="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span>
                                <span *ngIf="item.isError"><i class="glyphicon glyphicon-remove"></i></span>
                            </td>
                            <td nowrap>
                                <button type="button" class="btn btn-success btn-xs"
                                        (click)="item.upload(); setStorage()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                                    <span class="glyphicon glyphicon-upload"></span> Subir
                                </button>
                                <button type="button" class="btn btn-warning btn-xs"
                                        (click)="item.cancel()" [disabled]="!item.isUploading">
                                    <span class="glyphicon glyphicon-ban-circle"></span> Cancelar
                                </button>
                                <button type="button" class="btn btn-danger btn-xs"
                                        (click)="item.remove() ; removeFile(item.file?.name) ">

                                    <span class="glyphicon glyphicon-trash"></span> Remover
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div align="center">
                        <button type="button" class="btn btn-success btn-s"
                                (click)="uploader.uploadAll() ;setStorage()" [disabled]="!uploader.getNotUploadedItems().length">
                            <span class="glyphicon glyphicon-upload"></span> Subir todos
                        </button>
                        <button type="button" class="btn btn-warning btn-s"
                                (click)="uploader.cancelAll()" [disabled]="!uploader.isUploading">
                            <span class="glyphicon glyphicon-ban-circle"></span> Cancelar todos
                        </button>
                        <button type="button" class="btn btn-danger btn-s"
                                (click)="uploader.clearQueue() ; removeAll()"  [disabled]="!uploader.queue.length">
                            <span class="glyphicon glyphicon-trash"></span> Remover todos
                        </button>
                    </div>
         
            </div>
                <div id="error_docob" class="error" style="display:none;">* Debe agregar todos los documentos obligatorios y el formato debe ser PDF.</div>
                <div class="col-md-6 col-sm-8"></div>
            </div>
        </div> -->


        <!-- 
           <div *ngFor="let archivo of archivosForm">
            <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ archivo.name }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <div>
                                <div style="color: crimson" class="col-md-5 col-sm-5 col-lg-5 col-xs-5">
                                    {{ archivo.obligatorio ? 'Obligatorio' : '' }}
                                </div>
                                <div style="color: #5ff442" class="col-md-7 col-lg-7 col-sm-7 col-xs-7">
                                    {{ archivo.ready ? 'Archivo adjuntado' : '' }}
                                </div>
                            </div>

                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div align="center">
                        <div>
                            <button mat-raised-button color="primary" (click)="onInsert(); fileInput.click()">Adjuntar
                                archivo</button>
                            <input type="file" ng2FileSelect (onFileSelected)="onFileDrop($event, archivo )"
                                [uploader]="uploader" id="uploader-input-{{archivo.name}}" style="display: none"
                                accept="application/pdf" #fileInput />
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>  
        -->
        <div class="col-md-12" align="center" id="content" *ngIf="acotado">
            <div class="form-group" style="padding-top: 20px;margin-bottom: 2rem;" align="center">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4" align="center">
                        <button *ngIf="!yasubieron" mat-raised-button color="primary" style="padding-top: 5px;margin-bottom: 2rem;"
                            id="ingreso_documentos"
                            (click)="openAdjuntosModal(); nombreArchivo = ''; documentoNombre = ''; ">
                            Agregar Documentación
                            <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                        </button>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
            <div class="datatable_adjuntos">


                <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                    [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'"
                    style="width: 100%; text-align: left;">
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>NOMBRE DOCUMENTO</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.name}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>NOMBRE DE ARCHIVO</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.archivo}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>PESO</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{(row.peso + '').replace('.',',')}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>OPCIONES</span>
                        </ng-template>
                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                            <!--
                           <span (click)="get_antecedentes(rowIndex)" style="padding-right: 5px;"><i
                                class="glyphicon glyphicon-pencil"></i></span>
                       -->
                            <span *ngIf="!yasubieron" (click)="deleteFile(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>ESTADO</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <label style="color:green" *ngIf="row.estado=='Subido'">
                                {{row.estado}}
                            </label>
                            <label style="color:red" *ngIf="row.estado!='Subido'">
                                {{row.estado}}
                            </label>
                        </ng-template>
                    </ngx-datatable-column>


                </ngx-datatable>


            </div>
        </div>
    </fieldset>

    <ng-template #openModal>
        <h2 mat-dialog-title align="center">Recordatorio</h2>
        <mat-dialog-content>
            <div align="center">
                Por favor en el punto <strong>ANTECEDENTES QUE SE ADJUNTAN</strong>, marcar documentos que se van a
                adjuntar, para que estos se reflejen en el formulario a imprimir.
                Recuerda adjuntar el formulario firmado y escaneado en el siguiente paso.
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button mat-raised-button color="primary" id="cerrarModal" (click)="cerrarModal() ">Cerrar <i
                    class="alert-circle " aria-hidden="true "></i></button>
        </mat-dialog-actions>
    </ng-template>

    <ng-template #modalArchivos>
        <h2 mat-dialog-title align="center">Alerta</h2>
        <mat-dialog-content>
            <div align="center">
                Debe adjuntar todos los archivos <strong>Obligatorios</strong> indicados para este documento.
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button mat-raised-button color="primary" id="cerrarModal" (click)="cerrarModal() ">Cerrar <i
                    class="alert-circle " aria-hidden="true "></i></button>
        </mat-dialog-actions>
    </ng-template>











    <ng-template #modalAdjuntos>
        <h2 *ngIf="nombreMuni!='Lo Barnechea'" mat-dialog-title align="center">Agregar Documento </h2>
        <h2 *ngIf="nombreMuni=='Lo Barnechea'" mat-dialog-title align="center">Agregar Documento (pdf)</h2>
        <mat-dialog-content>
            <div  align="center">

                <p *ngIf="docRepetido">nombre ya existe, intente con otro</p>
                <mat-form-field class="col-md-12">
                    <mat-label>Nombre del Documento</mat-label>
                    

                    <input type="text" matInput [(ngModel)]="documentoNombre" 
                        (change)="enableUpload=true;">
 <!--solo si no son iguales a algun -->

                </mat-form-field>
                <p *ngIf="fileRepetido">este archivo ya fue adjunto, intente con otro</p>
                <mat-form-field matTooltip="{{!documentoNombre?'Agregue el nombre del documento primero':null}}"
                    class="col-md-12" style="cursor: pointer;">

                    <input type="text" matInput (click)=" file.click()" [disabled]="!documentoNombre || !enableUpload"
                        [value]="nombreArchivo" style="cursor: pointer;" onpaste="return false;" onCopy="return false"
                        onCut="return false" onDrag="return false" onDrop="return false" autocomplete=off>

                    <mat-icon matSuffix color="primary" (click)="file.click(); " *ngIf="documentoNombre">attach_file
                    </mat-icon>
                    <mat-icon matSuffix [ngStyle]="{'color':'grey'}" *ngIf="!documentoNombre">attach_file</mat-icon>
                    <!-- <mat-icon matSuffix color="secondary" *ngIf="!documentoNombre" >attach_file</mat-icon> -->


                </mat-form-field>


            </div> <input type="file" #file (change)="handleFileInput($event.target.files)" style="display:none;"
                [accept]="docAccept">
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button mat-raised-button color="primary" id="cerrarModal"
                (click)="documentoNombre = ''; nombreDeDocumento = ''; nombreArchivo = ''; docRepetido = false; fileRepetido = false; cerrarModal();  enableUpload=false; ">Cancelar
                <i class="alert-circle " aria-hidden="true "></i></button>

            <button mat-raised-button color="primary" id="addName"
                (click)="validarSubida(); enableUpload = false; "
                [disabled]="!documentoNombre || !nombreArchivo ">Adjuntar</button>
        </mat-dialog-actions>
    </ng-template>

</div>
<div class="separator"></div>


<ng-template #confirmaSubida *ngIf="!yasubieron">
    <h2 mat-dialog-title align="center">Debe adjuntar todos los archivos <strong>Obligatorios</strong> indicados para este documento.</h2>
    <mat-dialog-content>
        <div align="center">
            Está seguro de subir los archivos? una vez subidos ya no podrá editarlos.
            
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-raised-button color="warn" id="cerrarModal" (click)="cerrarModal() ">Cancelar<i
                class="alert-circle " aria-hidden="true "></i></button>
        <button mat-raised-button color="primary" id="addName" (click)="uploadAllfiles();"
            [disabled]="yasubieron">Aceptar</button>

    </mat-dialog-actions>
</ng-template>
